import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import ApiService from '../api.service.abstract';
import { FlightProviderEnum, FlightProviderSettings } from '@pulpo/pulpo-models';
import { APP_CONFIG } from '@pulpo/app-config';

@Injectable({ providedIn: 'root' })
export class FlightProviderSettingsService extends ApiService<FlightProviderSettings> {
  constructor(
    @Inject(APP_CONFIG) environment: any,
    protected http: HttpClient
  ) {
    super(environment, http, 'flight/api/flight-provider-settings');
    if (environment.name === 'localDev') {
      this.url = 'http://localhost:4300';
    }
  }

  findByCompanyId(
    companyId: number | string
  ): Observable<HttpResponse<FlightProviderSettings>> {
    return this.http.get<FlightProviderSettings>(
      `${this.url}/${this.endpoint}/getOrCreate?companyId=${companyId}`,
      {
        observe: 'response',
      }
    );
  }

  // Company resolved server-side from the admin's auth context - no
  // companyId param, unlike findByCompanyId above (a different consumer).
  getOrCreate(): Observable<HttpResponse<FlightProviderSettings>> {
    return this.http.get<FlightProviderSettings>(
      `${this.url}/${this.endpoint}/getOrCreate`,
      { observe: 'response' }
    );
  }

  toggleProdApiProvider(
    provider: FlightProviderEnum,
    enabled: boolean
  ): Observable<HttpResponse<FlightProviderSettings>> {
    // POST, not PATCH - the backend only exposes this route as POST.
    return this.http.post<FlightProviderSettings>(
      `${this.url}/${this.endpoint}/prod-api-providers`,
      { provider, enabled },
      { observe: 'response' }
    );
  }
}
